import React from 'react';

interface ExpandableTextProps {
  title: string;
  rows: string[] | any;
  isGroups?: boolean;
}

export const ExpandableText: React.FC<ExpandableTextProps> = ({ title, rows, isGroups = false }) => {
  const [open, setOpen] = React.useState(false);

  return (
    <div className="expandable-text">
      <a
        className="expandable-text__title"
        onClick={() => {
          setOpen((y) => !y);
        }}>
        {open ? 'Hide' : 'View'} {title}
      </a>
      {open &&
        !isGroups &&
        rows.map((row) => {
          return (
            <p key={row} className="expandable-text__row">
              {row}
            </p>
          );
        })}
      {open &&
        isGroups &&
        rows.map((row, groupIndex) => {
          return row.map((item, rowIndex) => {
            return (
              <React.Fragment key={`${groupIndex}-${rowIndex}`}>
                {groupIndex > 0 && rowIndex === 0 && <p className="or-tag">or</p>}
                <p key={item} className="expandable-text__row">
                  {item}
                </p>
              </React.Fragment>
            );
          });
        })}
    </div>
  );
};
